import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';

import { StatsResourceService } from './stats-resource.service';
import { StatGroupBy, GroupBy } from './stats.interface';

@Injectable({ providedIn: 'root' })
export class PresubscriptionsByAgeCategoryResolver {
  private readonly statsResource = inject(StatsResourceService);

  resolve(route: ActivatedRouteSnapshot): Observable<StatGroupBy[] | null> {
    const id = route.queryParamMap.get('seasonId');
    const groupBy = route.queryParams.groupBy as GroupBy | GroupBy[];

    const groupByArray = Array.isArray(groupBy)
      ? groupBy
      : groupBy
        ? [groupBy]
        : [];
    return id
      ? this.statsResource.getCountBy({
          season_id: +id,
          group_by: [
            GroupBy.AgeCategory,
            ...groupByArray.filter((x) => x !== GroupBy.AgeCategory),
          ],
        })
      : of(null);
  }
}
